import { t } from "../i18n";
import { initial } from "../lib/format";
import { href, type Route } from "../lib/router";
import { useHeroData } from "../state/heroData";
import { Avatar } from "./Avatar";
import { Icon } from "./Icon";
import { Link } from "./Link";

/**
 * Верхняя полоса: герой слева (его логотип или имя шрифтом темы), вход или аккаунт
 * справа. Вход выглядит как вход героя — сессия платформенная, но сайт его.
 */
export function TopBar({ route, overlay = false }: { route: Route; overlay?: boolean }) {
  const { hero, me } = useHeroData();
  const onHome = route.name === "hero";
  const editorial = onHome && (hero.slug === "chef" || hero.slug === "luca" || hero.slug === "theo");
  const editorialClass = editorial ? ` topbar--editorial topbar--${hero.slug === "theo" ? "theo" : "luca"}` : "";
  const next = route.name === "join" || route.name === "signin" ? null : window.location.pathname + window.location.search;

  return (
    <header className={`topbar${overlay ? " topbar--overlay" : ""}${editorialClass}`}>
      <div className="topbar__inner">
        <Link to={href.hero()} className="topbar__brand" aria-label={t("nav.home", { hero: hero.name })}>
          {!onHome && <Icon name="chevronLeft" size={20} className="topbar__back" />}
          {hero.theme.logoUrl ? (
            <img src={hero.theme.logoUrl} alt={hero.name} className="topbar__logo" />
          ) : (
            <>
              <Avatar src={hero.theme.portraitUrl} name={hero.name} size={30} />
              {/* На launch-страницах имя работает как wordmark; у обычной страницы оно уже крупно на обложке. */}
              {(!onHome || editorial) && <span className="topbar__name">{hero.name}</span>}
            </>
          )}
        </Link>
        <nav className="topbar__actions">
          {me ? (
            <Link to={href.account()} className="topbar__me" aria-label={t("nav.account")} title={me.email}>
              <span className="avatar avatar--letter" style={{ width: 34, height: 34, fontSize: 15 }}>
                {initial(me.displayName)}
              </span>
            </Link>
          ) : (
            route.name !== "signin" &&
            route.name !== "join" && (
              <Link to={href.signin(next === "/" ? null : next)} className="btn btn--ghost btn--sm">
                {t("nav.signIn")}
              </Link>
            )
          )}
        </nav>
      </div>
    </header>
  );
}
